import React, { useEffect, useState } from 'react';
import { Tag, Tooltip, Modal, Button, message } from 'antd';
import { AiOutlineYoutube, AiOutlineTwitter, AiOutlineHeart, AiOutlineDelete } from 'react-icons/ai';
import './InfluencerCardComponent.styles.scss';
import AddInfluencerToListModal from '../Discovery/AddInfluencerToListModal';
import { useGlobalState } from '../../../store/state';
import { RemoveInfluencerFromList } from '../../../apis/Brand/Discovery/RemoveInfluencerFromList';
import { Link } from 'react-router-dom';
import PlatformIconRender from '../../Common/PlatformIconRender';
import { Config } from '../../../Config';

const InfluencerCardComponent = ({
  firstname,
  lastname,
  username,
  followers,
  postsCount,
  id,
  profile_pic,
  city_living,
  country,
  picture,
  interests,
  allowAddList,
  allowRemoveList,
  platform,
  listId,
  setListLoadingData,
  allowProfileBtn,
}, props) => {
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');
  const [addList, setAddList] = useState({
    visible: false,
  });

  const showModal = () => {
    setAddList({
      ...addList,
      visible: true,
    });
  };
  const onCancel = () => {
    setAddList({
      ...addList,
      visible: false,
    });
  };
  const handleModalOk = () => {
    setAddList({
      ...addList,
      visible: false,
    });
  };

  const removeInfluencerFromList = () =>{
    const _data = {
      influencerid: id,
      brand: company.selected.id,
      listid: listId,
    };
    // console.log("remover settings",_data)
    RemoveInfluencerFromList(user.accessToken, _data).then(({ status, response })=>{
      console.log('response', response);
      if (status === 200) {
        message.success(`${firstname} ${lastname} removed from list`);
        setListLoadingData(listId, 1); // its drilled 2 step inside (coming from page)
      } else {
        message.error(`There is some issue while removing list`);
      }
    });
  };
  return (
    <div className="col-lg-4 col-md-6 p-2">
      <div className="common_card influ_card text-center">
        {
          allowAddList?
            <React.Fragment>
              <Tooltip title="Add this user to a list">
                <div className="influ_card--add"
                  onClick={showModal}>
                  <AiOutlineHeart />
                </div>
              </Tooltip>
              {/* MODAL FOR ADD USER */}
              <AddInfluencerToListModal
                visible={addList.visible}
                onCancel={onCancel}
                onOk={handleModalOk}
                firstname={firstname}
                lastname={lastname}
                platform={platform}
                influid={id}
              />
            </React.Fragment>:
            null
        }
        {
          allowRemoveList?
            <React.Fragment>
              <Tooltip title="Remove this user from list">
                <div className="influ_card--add"
                  onClick={removeInfluencerFromList}>
                  <AiOutlineDelete />
                </div>
              </Tooltip>
            </React.Fragment>:
            null
        }
        <div className="influ_card--avatar ">
          <img src={profile_pic || 'https://via.placeholder.com/100?text=No Image'}
            className="img-fluid"
            alt="" />
        </div>
        <h5 className="influ_card--name">{`${firstname} ${lastname}`}</h5>
        <div className="d-flex flex-wrap align-items-center text-center justify-content-center">

          {username && <div className="influ_card--handle mx-1">@{username}</div>}
          <div className="influ_card--loc mx-1">{city_living || ''} {country || Config.country}</div>
        </div>
        <div className="influ_card--interests mt-3">
          {interests && interests.length ?
            <>
              {interests.map((int, index)=>{
                if (index <= 1) {
                  return <Tooltip key={int+index}
                    title={int}><Tag color="purple" >{int}</Tag></Tooltip>;
                }
              })}
              {interests.length >= 2 ?
                <Tooltip title={
                  <>Other Interests:
                    {interests.map((restInt, i)=>{
                      if (i >= 2) {
                        return <div key={i+restInt}>{restInt}</div>;
                      }
                    })}
                  </>
                }>
                  <Tag color="purple">+{interests.length - 2}</Tag>
                </Tooltip>:
                null
              }
            </>:
            <span className="no-interests"><Tag>No Interets</Tag></span>
          }
          {/* <Tag>Entertainment</Tag>
                    <Tag>+4</Tag> */}
        </div>
        <div className="influ_card--platforms my-2">
          <span><PlatformIconRender platform={platform}
            username={username}/></span>
          {/* {
                        youtube_account && youtube_account.enabled ?
                        // <span><AiOutlineYoutube color="#FF0000" /></span>
                        :null
                    }
                    {
                        twitter_account && twitter_account.enabled ?
                        <span><AiOutlineTwitter color="#1DA1F2" /></span>
                        :null
                    }
                    {
                        instagram_account && instagram_account.enabled ?
                        <span><AiOutlineTwitter color="#1DA1F2" /></span>
                        :null
                    } */}
        </div>
        <div className="influ_card_stats d-flex justify-content-between">
          <div className="influ_card_stats_each">
            <h4 className="influ_card_stats_each--val"> { followers || 0 }</h4>
            <div className="influ_card_stats_each--label">Followers</div>
          </div>
          <div className="influ_card_stats_each">
            <h4 className="influ_card_stats_each--val">{ postsCount || 0 }</h4>
            <div className="influ_card_stats_each--label">Posts</div>
          </div>
          {/* <div className="influ_card_stats_each">
            <h4 className="influ_card_stats_each--val">2.5%</h4>
            <div className="influ_card_stats_each--label">Avg.ER</div>
          </div> */}
        </div>
        {
          allowProfileBtn ?
            <div className="pt-3 influ_card_actions">

              <Link to={`/brand/${company.selected.id}/discover/profile/${id}`}>
                <Button className="common_button outlined small"
                >View Profile</Button>
              </Link>
            </div>:
            null
        }
      </div>
    </div>
  );
};

export default InfluencerCardComponent;
